import { useCallback, useEffect, useState } from 'react';

export const THEME_PRESETS = ['spa', 'clinical', 'dark', 'contrast'];

const STORAGE_KEY = 'themePreset';

const apply = (preset) => {
  const root = document.documentElement;
  if (preset === 'spa') {
    delete root.dataset.themePreset; // spa = the default token set
  } else {
    root.dataset.themePreset = preset;
  }
};

/**
 * Theme preset state, persisted per browser. "spa" (default ink-rail
 * identity), "clinical" (cool slate/blue), "contrast" (high contrast,
 * no translucency). cycle() steps through them in order.
 */
const useThemePreset = () => {
  const [preset, setPreset] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return THEME_PRESETS.includes(saved) ? saved : 'spa';
  });

  useEffect(() => {
    apply(preset);
    localStorage.setItem(STORAGE_KEY, preset);
  }, [preset]);

  const cycle = useCallback(() => {
    setPreset((prev) => {
      const idx = THEME_PRESETS.indexOf(prev);
      return THEME_PRESETS[(idx + 1) % THEME_PRESETS.length];
    });
  }, []);

  return { preset, setPreset, cycle };
};

export default useThemePreset;
